import { IContact } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { getContactPhone } from './getContactPhone'

export const getAdminContactData = (contact?: IContact) => {
  if (!contact) {
    return {}
  }

  const adminContactPhoneData = getContactPhone(contact)

  return {
    CompanyAdminEmail: contact.Email,
    CompanyAdminWorkPhone: adminContactPhoneData.phone,
    CompanyAdminWorkPhonePrefix: adminContactPhoneData.code,
  }
}
